export interface Config extends Record<string, any> { }

export namespace Config {
    export function load(): Config {
        const configData = JSON.stringify(process.env.WEB_DROP_IN_CONFIG)
        console.log(configData)
        const config: Config = JSON.parse(configData);
        console.log(config)
        return config;
    }
}

export interface ProviderOptions {
    readonly name: string;
    readonly options?: any;
}
